import React from 'react';
import LaunchIcon from '@mui/icons-material/Launch';
import { TextDefault } from '@awarego-ui/components';

function IntegrationDetailSidebar({ href, product }) {
    return (
        <div className="integration-detail-sidebar">
            <div className="d-flex align-items-center">
                <a href={href} target="_blank" rel="noopener noreferrer">
                    <TextDefault themed bold>
                        Online documentation{' '}
                    </TextDefault>
                    <LaunchIcon fontSize="small" color="primary" />
                </a>
            </div>
            <p>Learn more on how to integrate with {product}.</p>
        </div>
    );
}

export default IntegrationDetailSidebar;
